// extracted by mini-css-extract-plugin
export default {"footerPosts":"_3O7Va","categoriesControls":"_3yjzk"};